export type DictionaryDirectoryRow = {
  type: string;
  name: string;
};

export type DictionaryDirectoryFilter = {
  field: string;
  value: string;
};

export const paginateDictionaryDirectory = (
  rows: DictionaryDirectoryRow[],
  filter: DictionaryDirectoryFilter,
  requestedPage: number,
  pageSize: number,
) => {
  const needle = filter.value.trim().toLocaleLowerCase();
  const filtered = needle ? rows.filter(row => {
    if (filter.field === "type" || filter.field === "name") {
      return row[filter.field].toLocaleLowerCase().includes(needle);
    }
    return [row.type, row.name].some(value =>
      value.toLocaleLowerCase().includes(needle));
  }) : rows;
  const count = filtered.length;
  const totalPages = Math.max(1, Math.ceil(count / pageSize));
  const currentPage = Math.min(Math.max(1, requestedPage), totalPages);
  const start = (currentPage - 1) * pageSize;
  return {
    data: filtered.slice(start, start + pageSize),
    count,
    currentPage,
    totalPages,
  };
};
